import {Component, Inject, Input} from '@angular/core';
import {ContentResponse} from "../interface/contentResponse";
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {AddUserCardContentComponent} from "../add-user-card-content/add-user-card-content.component";
import {UserContentComponent} from "../user-content/user-content.component";
import {ContentType} from "../interface/contentType";
import {ContentService} from "../service/content.service";
import {UserCardContentListService} from "./user-card-content-list.service";

@Component({
  selector: 'app-user-card-content-list',
  templateUrl: './user-card-content-list.component.html',
  styleUrl: './user-card-content-list.component.scss'
})
export class UserCardContentListComponent {
  @Input() content: ContentResponse[] = [];
  @Input() contentType: string | any;
  @Input() showMore: boolean | any
  @Input() documentsCount: number | any
  @Input() userCardId: bigint | undefined
  itemsToShow: number = 12

  constructor(
      @Inject(MAT_DIALOG_DATA) private data: { message: string },
      private dialogRefOfContent: MatDialogRef<UserContentComponent>,
      private dialog: MatDialog,
      private contentService: ContentService
  ) {
  }

  isOverLimit(content: ContentResponse) : boolean {
    return content.contentType == ContentType.DOCUMENT && this.documentsCount > 0;
  }

  openAddContent(contents: ContentResponse) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      content: contents,
      userCardId: this.userCardId
    }
    dialogConfig.height = 'auto';

    const openedDialogRef = this.dialog.open(AddUserCardContentComponent, dialogConfig);
    UserCardContentListService.dialogRefSubject.next(openedDialogRef);
  }

  getContentImage(image: string) {
    return this.contentService.getImage(image);
  }

  toggleShowMore() {
    this.showMore = !this.showMore;
    this.itemsToShow = this.showMore ? this.content.length : 12;
  }

}
